import React, { useContext, useState, useEffect, useRef } from 'react';
import { Table, Input, Form } from 'antd';

const EditableContext = React.createContext();

const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};

const EditableCell = ({ title, editable, children, dataIndex, inputType, record, handleSave, ...restProps }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef();
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current.focus();
        }
    }, [editing]);

    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };

    const save = async () => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({ ...record, ...values });
        } catch (errInfo) {
            // eslint-disable-next-line no-console
            console.log('Save failed:', errInfo);
        }
    };

    let childNode = children;

    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={[
                    {
                        required: true,
                        message: `${title} is required.`,
                    },
                ]}
            >
                <Input ref={inputRef} type={inputType} onPressEnter={save} onBlur={save} />
            </Form.Item>
        ) : (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <div
                className="gd-editable-cell-value-wrap"
                role="textbox"
                tabIndex="0"
                style={{
                    paddingRight: '2.4em',
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }

    return <td {...restProps}>{childNode}</td>;
};

const cols = [
    {
        title: 'Total No. Rooms In Hotel',
        dataIndex: 'hotelSize',
        width: '27%',
        editable: true,
    },
    {
        title: 'Estimated ADR (without group)',
        dataIndex: 'estADR',
        width: '27%',
        editable: true,
    },
    {
        title: 'Cost of Occupied Room',
        dataIndex: 'occupiedRoomCost',
        width: '27%',
        editable: true,
    },
    {
        title: 'Nett ADR',
        dataIndex: 'netADR',
        width: '19%',
    },
];

const ADRTable = ({ formData, onADRRowChange }) => {
    const handleSave = (row) => {
        onADRRowChange(row);
    };

    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };
    const columns = cols.map((col) => {
        if (!col.editable) {
            return col;
        }

        return {
            ...col,
            onCell: (record) => ({
                ...col,
                record,
                inputType: col.dataIndex === 'roomType' ? 'text' : 'number',
                handleSave,
            }),
        };
    });

    return (
        <div>
            <Table
                components={components}
                rowClassName="gd-editable-row"
                bordered
                rowKey="id"
                dataSource={formData.roomTypes}
                columns={columns}
                pagination={false}
            />
        </div>
    );
};
export default ADRTable;
